import './foundation.scss';
import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';

/**
 * Foundation
 *
 * To import a new component from Foundation, import the module and activate the plugin.
 *
 * For example:
 *     import { Accordion } from 'foundation-sites/js/foundation.accordion';
 *     Foundation.plugin(Accordion, 'Accordion');
 *
 * See this file for more component options:
 *     foundation-sites/js/entries/foundation;
 */
Foundation.addToJquery($);
$(document).foundation();